import React, { Component } from 'react'
import Flickity from 'flickity'
import { TextTemplateStyle } from './../../styles'

export default class FullTextTemplate extends Component {

  componentDidMount() {
    if (this.props.images) {
      this.flkty = new Flickity( this.slider)
    }
  }

  render() {
    const {type, title, description, description2} = this.props

    return (
      <div className={`product-template--base product-template template ${TextTemplateStyle}`}>
        <div className="template-scroll">
          <div className="template-content">
            { title && ( <h2 className="subtitle">{title}</h2> ) }
            <div className="flex">
              <div className="template-left">
                { description && ( <div className="content" dangerouslySetInnerHTML={{__html: description}} /> )}
              </div>
              <div className="template-right ">
                { description2 && ( <div className="content" dangerouslySetInnerHTML={{__html: description2}} /> )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SliderTemplates/FullTextTemplate.js